<template>
  <span>
  <!-- Page Heading -->
          <div class="d-sm-flex align-items-center justify-content-between mb-4" >
            <h2 class="h3 mb-0 text-gray-800">Manage Admins</h2>
          </div>
          
                    <div class="row">
            <div class="col-12">
              <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                <li class="nav-item" role="presentation">
                  <a class="nav-link active" id="pills-home-tab" data-toggle="pill"
                   href="#pills-home" role="tab" aria-controls="pills-home" aria-selected="true">Create New Admin</a>
                </li>
                <li class="nav-item" role="presentation">
                  <a class="nav-link" id="pills-profile-tab" data-toggle="pill" 
                  href="#pills-profile" role="tab" aria-controls="pills-profile" aria-selected="false">View Created Admins</a>
                </li>
              </ul>
            </div>
            <!-- form area -->
            <div class="col-12">
                <div class="tab-content" id="pills-tabContent">
                    <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                      <div class="col-xl-8 col-12">
                        <div class="card shadow mb-4">
                          <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                            <h6 class="m-0 font-weight-bold text-info"> Create Admin</h6>
                          </div>
                          <!-- Card Body -->
                          <div class="card-body">
                               <form @submit.prevent="createAdmin">
                                <div class="form-group">
                                    <label for="exampleInputEmail1">Name</label>
                                    <input type="text" v-model="name" class="form-control" 
                                      id="exampleInputEmail1" aria-describedby="emailHelp"
                                      placeholder="Enter Admin Name" required>
                                </div>
                                <div class="form-group">
                                    <label for="exampleInputPassword1">Email</label>
                                    <input type="email" class="form-control" v-model="email" id="exampleInputPassword1"
                                    placeholder="Enter Admin Email" required>
                                </div>
                                 <p class="text-success" v-if="success">{{success}}</p>
                                 <p class="text-danger" v-if="error">{{error}}</p>
                                <button type="submit" class="btn btn-info">
                                    Submit
                                    <div class="spinner-grow" role="status" v-if="loading">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                </button>
                            </form>
                            </div>
                          </div>
                        </div>
                     </div>
                     
                <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                    <div class="col-xl-8">
                        <div class="card shadow mb-4">
                          <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                            <h6 class="m-0 font-weight-bold text-info">Admins</h6>
                          </div>
                            <div class="card-body">
                                <div class="col-12 mb-4" v-if="admins.length === 0 && !loading">
                                  <div class="card border-left-info shadow h-100 py-2">
                                    <div class="card-body">
                                      <div class="row no-gutters align-items-center">
                                        <div class="col mr-2">
                                          <div class="text-xs font-weight-bold text-primary text-uppercase mb-1"></div>
                                          <div class="h5 mb-0 font-weight-bold text-gray-800">
                                            <p class="p-5">No Admin Created</p> 
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                  <div class="col-12 mb-4" v-if="loading">
                                  <div class="card border-left-info shadow h-100 py-2">
                                    <div class="card-body">
                                      <div class="row no-gutters align-items-center">
                                        <div class="col mr-2">
                                          <div class="text-xs font-weight-bold text-primary text-uppercase mb-1"></div>
                                          <div class="h5 mb-0 font-weight-bold text-gray-800">
                                            <p class="">
                                              ...Loading data 
                                              </p> 
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="col-12 mb-4" v-if="admins > 0 && !loading">
                                  <div class="card border-left-info shadow h-100 py-2">
                                    <div class="card-body">
                                        <div class="table-responsive">
                                           <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
                                             <thead>
                                              <tr>
                                                <th>Name</th>
                                                <th>Email</th>
                                              </tr>
                                             </thead>
                                             <tbody>
                                               <tr v-for="(admin, key) in admins" :key="key">
                                                 <td>{{admin.name}}</td>
                                                 <td>{{admin.email}}</td>
                                               </tr> 
                                             </tbody>
                                             <tfoot>
                                               <tr>
                                                 <th>
                                                   Name
                                                 </th>
                                                 <th>
                                                   Email
                                                 </th>
                                               </tr>
                                             </tfoot>
                                           </table>
                                        </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                          </div>
                        </div>
            </div>
          </div><!--- end of pills content -->
        </div>
      </div>
  </span>
</template>

<script>
import $ from 'jquery'
$('.toast').toast(500)

export default {
  data() {
    return {
      email:'',
      name:''
    }
  },
  methods: {
      createAdmin(){
          this.$store.dispatch('createAdmin', {email:this.email, name:this.name})
      }
  },
  computed:{
      admins() {
        return this.$store.state.admin.admins;
      },
      success(){
        return this.$store.state.admin.success
      },
      loading() {
        return this.$store.state.admin.loading
      },
       error() {
        return this.$store.state.admin.error
      }
  },
  created(){
    console.log('Created', this.admins)
  }
}
</script>

<style>

</style>